import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useDispatch from 'hooks/useDispatch'
import useFlag from 'hooks/useFlag'
import useGrantedRewardExpirationNagDismissal from 'hooks/useGrantedRewardExpirationNagDismissal'
import { useCallback } from 'react'
import { push } from 'react-router-redux'
import { useAbility } from 'utilities/ability'

type UseGrantedRewardExpirationNagResult = {
  showBanner: boolean
  dismiss: () => void
  handleConfigure: () => void
}

export default function useGrantedRewardExpirationNag(): UseGrantedRewardExpirationNagResult {
  const dispatch = useDispatch()
  const flagEnabled = useFlag('mx-granted-reward-expiration-nag', false)
  // The CTA deep-links to the settings tab, which only renders when the
  // settings flag is on. Require it too so the banner can't strand the user
  // on a tab that doesn't exist.
  const settingsFlagEnabled = useFlag(
    'mx-granted-reward-expiration-settings',
    false
  )
  const merchant = useCurrentMerchant()
  const canManageMerchantSettings = useAbility().can(
    'manage',
    'MerchantSettings'
  )
  const [isDismissed, dismiss] = useGrantedRewardExpirationNagDismissal()

  const hasMadeChoice = merchant?.granted_reward_retire_after_days_set === true

  const merchantNeedsNag =
    !!merchant?.id && !hasMadeChoice && !!merchant?.has_granted_reward_backlog

  const showBanner =
    !!flagEnabled &&
    !!settingsFlagEnabled &&
    canManageMerchantSettings &&
    !isDismissed &&
    merchantNeedsNag

  const handleConfigure = useCallback(() => {
    dispatch(push('/rewards#settings'))
  }, [dispatch])

  return { showBanner, dismiss, handleConfigure }
}
